// extracted by mini-css-extract-plugin
export default {"modal__footer":"style_modal__footer__ph+jY","modal__footer__button_next":"style_modal__footer__button_next__ZtSz6","hidden":"style_hidden__fcgL1"};